import React from "react";
import { FormattedDate, FormattedTime } from "react-intl";
import moment from "moment";
import MediaBreakpoints from "Utils/MediaBreakpoints";
import CurrencyLabel from "Utils/CurrencyLabel";

class RentalStaff extends React.Component {
  renderTimeIn = (timeZone) => {
    const { item } = this.props;
    return (
      <span>
        <FormattedDate
          value={item.staffSchedule.inTime}
          month="numeric"
          year="numeric"
          day="numeric"
        />{" "}
        <FormattedTime
          value={item.staffSchedule.inTime}
          timeZone={timeZone}
          timeZoneName="short"
        />
      </span>
    );
  };

  renderTimeOut = (timeZone) => {
    const { item } = this.props;
    return (
      <span>
        <FormattedDate
          value={item.staffSchedule.outTime}
          month="numeric"
          year="numeric"
          day="numeric"
        />{" "}
        <FormattedTime
          value={item.staffSchedule.outTime}
          timeZone={timeZone}
          timeZoneName="short"
        />
      </span>
    );
  };

  render() {
    const {
      item,
      showItemImages,
      showUnitPricingToCustomers,
      showFeesCol,
      showDiscountsCol,
    } = this.props;
    const timeZone = moment.tz.guess(item.staffSchedule.inTime);
    return (
      <MediaBreakpoints
        desktop={
          <tbody>
            <tr className="bottom">
              <td colSpan={showItemImages ? "2" : "1"}>{item.name}</td>
              <td className="right">{item.size}</td>
              {showUnitPricingToCustomers && (
                <td className="right">
                  <CurrencyLabel value={item.cost / item.size} />
                  /Each
                </td>
              )}
              {showFeesCol && <td className="right" />}
              {showDiscountsCol && <td className="right" />}
              <td className="right">
                <CurrencyLabel value={item.cost} />
              </td>
            </tr>
            <tr className="top noBorder">
              <td
                colSpan={
                  (showItemImages
                    ? showUnitPricingToCustomers ? 5 : 4
                    : showUnitPricingToCustomers ? 4 : 3) +
                  (showFeesCol ? 1 : 0) +
                  (showDiscountsCol ? 1 : 0)
                }
              >
                <label className="highlight">Time In</label>{" "}
                {this.renderTimeIn(timeZone)}{" "}
                <label className="highlight">Time Out</label>{" "}
                {this.renderTimeOut(timeZone)}
              </td>
            </tr>
          </tbody>
        }
        mobile={
          <tbody className="mobileItemContent">
            <tr className="noBorder">
              <td>
                {item.name}
                {/* Stacked labeled lines instead of columns on mobile, matching
                    the RentalItem mobile line pattern (.caption.lineDetails). */}
                <div className="caption lineDetails">
                  <div>
                    <strong>Time In</strong> {this.renderTimeIn(timeZone)}
                  </div>
                  <div>
                    <strong>Time Out</strong> {this.renderTimeOut(timeZone)}
                  </div>
                  <div>
                    <strong>Quantity</strong> {item.size}
                  </div>
                  {showUnitPricingToCustomers && (
                    <div>
                      <strong>Rate</strong>{" "}
                      <CurrencyLabel value={item.cost / item.size} />
                      /Each
                    </div>
                  )}
                  <div>
                    <strong>Subtotal</strong>{" "}
                    <CurrencyLabel value={item.cost} />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        }
      />
    );
  }
}

export default RentalStaff;
